import { useEffect, useRef, useState } from 'react';

import * as serviceWorker from '../../serviceWorker';

export const useServiceWorker: () => {
  updateAvailable: boolean;
  updateApp: VoidFunction;
  closeNotification: VoidFunction;
} = () => {
  const [showUpdateAvailable, setUpdateAvailable] = useState<boolean>(false);
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);
  const isRefreshing = useRef<boolean>(false);

  const onServiceWorkerUpdate = (registration: ServiceWorkerRegistration) => {
    setUpdateAvailable(true);
    setWaitingWorker(registration.waiting);
  };

  useEffect(() => {
    async function init() {
      serviceWorker.register({
        onUpdate: onServiceWorkerUpdate,
      });
      if (!waitingWorker) {
        const registration = await navigator.serviceWorker?.getRegistration();
        registration && registration.waiting && onServiceWorkerUpdate(registration);
      }
      navigator.serviceWorker?.addEventListener('controllerchange', () => {
        if (!isRefreshing.current) {
          window.location.reload();
          isRefreshing.current = true;
        }
      });
    }
    init();
  }, []);

  const updateApp = () => {
    waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
    setUpdateAvailable(false);
  };

  return {
    updateAvailable: showUpdateAvailable,
    updateApp,
    closeNotification: () => setUpdateAvailable(false),
  };
};
